import { render } from "./task_card.html?vue&type=template&id=6c4394fb&external"
import script from "./task_card.js?vue&type=script&lang=js&external"
export * from "./task_card.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__